export default __webpack_public_path__ + "static/media/about.c4ee9cc5.jpg";